export default "__VITE_ASSET__CSI4RmpY__"